import { useEffect, useState } from "react";
import { Share2, Copy, Home } from "lucide-react";
import { shareOut, copyOut, personalLink } from "@/lib/partnerKit";
import { loadShareOrigin } from "@/lib/origin";

// Launch-day post: "Xcelio has a new home" with his personal link. Only once xcelio.app is verified live.
export default function NewHomePost({ k }) {
  const [live, setLive] = useState(null);
  useEffect(() => { loadShareOrigin().then(setLive); }, []);
  if (!live) return null;
  const link = personalLink(k.slug, "newhome");
  const host = live.replace(/^https?:\/\//, "");
  const text = `Xcelio has a new home: ${host}\n\nIt's the AI confidence coach I've been using: you talk, it listens, remembers, and helps you show up as more of yourself. Not more impressive, just more you.\n\nCome and meet Adelaida (or Richard): ${link}`;
  const log = { intent: "newhome", channel: "newhome" };
  return (
    <section className="mt-8 rounded-3xl border border-primary/30 bg-gradient-to-br from-primary/[0.12] via-transparent to-transparent p-6 sm:p-7" data-testid="partner-newhome-card">
      <p className="text-[10px] uppercase tracking-[0.22em] text-primary flex items-center gap-2"><Home className="w-3.5 h-3.5" /> Launch day · ready to share</p>
      <div className="mt-4 rounded-2xl bg-background/60 border border-white/10 p-6 text-center">
        <p className="font-serif text-2xl sm:text-3xl leading-tight">Xcelio has a new home</p>
        <p className="mt-2 text-primary font-medium tracking-wide" data-testid="partner-newhome-host">{host}</p>
        <p className="mt-3 text-sm text-muted-foreground">Don't become more impressive. Become more you.</p>
      </div>
      <p className="mt-4 whitespace-pre-line text-sm leading-relaxed text-foreground/85" data-testid="partner-newhome-text">{text}</p>
      <div className="flex flex-wrap gap-2 mt-5">
        <button onClick={() => shareOut({ text, log })} className="inline-flex items-center gap-1.5 rounded-full bg-primary text-primary-foreground px-5 py-2.5 text-sm" data-testid="partner-newhome-share"><Share2 className="w-4 h-4" /> Share</button>
        <button onClick={() => copyOut(text, log)} className="inline-flex items-center gap-1.5 rounded-full border border-border px-5 py-2.5 text-sm" data-testid="partner-newhome-copy"><Copy className="w-4 h-4" /> Copy</button>
      </div>
    </section>
  );
}
